export default "/local/templates/atc_1pdr/dist/images/icon-chevron-down.svg?e70b06563422e5f8f270dfcea82a36c1";